import { defineLocaleCatalog } from '@/shared/i18n'
import { useLocaleMessages } from '@/shared/composables/useI18n'
import { buildPresetsEn } from './en.ts'
import { buildPresetsRu } from './ru.ts'

export const buildPresetsCatalog = defineLocaleCatalog({
  en: buildPresetsEn,
  ru: buildPresetsRu,
})

export function useBuildPresetMessages() {
  return useLocaleMessages(buildPresetsCatalog)
}
